import { Button, Modal } from "@adafia/ui";
import { AlertTriangle } from "lucide-react";
import type React from "react";

interface DeleteConfirmationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
}

export const DeleteConfirmationModal: React.FC<
	DeleteConfirmationModalProps
> = ({ isOpen, onClose, onConfirm, title }) => {
	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Delete Resource">
			<div className="delete-confirm-content">
				<div className="warning-icon-box">
					<AlertTriangle size={32} className="text-error" />
				</div>
				<p className="delete-confirm-text">
					Are you sure you want to delete <strong>{title}</strong>? This action
					cannot be undone.
				</p>
				<div className="modal-actions-refined">
					<Button type="button" variant="secondary" onClick={onClose}>
						Cancel
					</Button>
					<Button
						type="button"
						variant="primary"
						className="btn-danger"
						onClick={onConfirm}
					>
						Delete
					</Button>
				</div>
			</div>
		</Modal>
	);
};
